import { Main } from '../Main/Main';
import { Routing } from '../Routes';
import axios from 'axios';
import { ApiActionResponse } from '../../types';
import { useConfig } from '../../config';
import { useSession } from '../../state/session';
import { useParams, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { MessagesContainer } from '../../state/messages';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';

type UrlParams = { customerId: string; code: string };

export const ConfirmDeletePage = (): JSX.Element => {
	const { customerId, code } = useParams<UrlParams>();
	const t = useTranslation().deleteAccount;
	const { logout } = useSession();
	const { api } = useConfig();
	const history = useHistory();
	const [error, setError] = useState('');
	const alert = MessagesContainer.useContainer();

	const confirmDelete = {
		customerId: customerId,
		code: code,
	};

	useEffect(() => {
		deleteAccount();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	async function signout() {
		if (await logout()) {
			history.push('/');
		}
	}

	async function deleteAccount() {
		const payload: UrlParams = confirmDelete;
		try {
			const res = await axios.post<ApiActionResponse>(`${api}me/delete-account/confirm.json`, payload);
			if (res.data.success) {
				alert.set({
					type: 'success',
					message: t.weHaveReceivedConfirmation,
				});
				signout();
			}
		} catch (e) {
			setError('error');
		}
	}

	return <Main>{error && <ErrorMessage />}</Main>;
};

export const confirmDeleteRouting: Routing = {
	path(urls) {
		return `${urls.removeAccount}/:customerId/:code`;
	},
	component: ConfirmDeletePage,
	requiresAuth: false,
};
